export class Image {
  constructor (
    public readonly title: string,
    public readonly alt: string,
    public readonly medium: string,
    public readonly full: string,
  ) {}
}

export class Post {
  constructor (
    public readonly id: string,
    public readonly title: string,
    public readonly excerpt: string,
    public readonly content: string,
    public readonly tags: string[],
    public readonly img: Image | null,
  ) {}
}

export class Page {
  constructor (
    public readonly title: string,
    public readonly content: string,
    public readonly img: Image,
  ) {}
}
